import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "../../utils";

const stylesheet = StyleSheet.create({
    hidden: {
        ...webStyle({
            clip: "rect(0 0 0 0)",
            whiteSpace: "nowrap",
            position: "absolute",
            overflow: "hidden",
            margin: -1,
            height: 1,
            width: 1
        })
    }
});
export default stylesheet;
